export const getUserCareProvider = state => state.user.user?.careProviders || [];